// easyui-texteditor.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, AfterViewInit, Input, Output, ElementRef, ViewChild, EventEmitter } from '@angular/core';

declare let $: any;

@Component({
  selector: 'easyui-texteditor',
  template: `
		<div #host>
			<ng-content></ng-content>
		</div>
	`
})
export class EasyuiTextEditorComponent implements AfterViewInit {
	private host: any;
	@ViewChild('host') hostElement: ElementRef;
	@Input('options') options: any = {};
	@Input('tipo') tipo = '';
  @Output() onbutton = new EventEmitter<string>();

  constructor() {
  }

  ngAfterViewInit() {
    this.configura(this.options);
  }

	public open(opts?: any) {
		this.host.texteditor('open');
		if (opts && opts.top && opts.left) {
			this.host.texteditor('resize', {top: opts.top, left: opts.left});
		}
	}

	public close() {
		this.host.texteditor('close');
	}

	public center() {
		this.host.texteditor('center');
	}

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  // metodi privati

  private configura(options) {
    this.host = $(this.hostElement.nativeElement);
		  let localoptions = {
			width: 400,
			height: 200,
			closed: true,
			buttons: [
				{
					text: 'OK', width: 55, handler: () => {
						this.onbutton.emit('ok');
						this.close();
					}
				}
			]
		};
    this.host.texteditor({width: '100%'});
    localoptions = Object.assign(localoptions, options);
    this.host.texteditor(localoptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-texteditor.component.ts